import React from 'react';

import { onChange, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            leaveCode: props.code,
            status: { name: 'status', value: '', options: [{ code: true, name: 'Approved' }, { code: false, name: 'Rejected' }], error: '', isRequired: true },
            comment: { name: 'comment', value: '', error: '', isRequired: false },
        }
    }

    render() {
        const { status, comment } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Status <small>*</small></label>
                                        <select
                                            className={status.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            name={status.name}
                                            value={status.value}
                                            onChange={this.onChange}
                                        >
                                            <option>Select a status</option>
                                            {
                                                status.options.map(function (item: any, index: number) {
                                                    return (
                                                        <option key={index} value={item.code}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Comments <sup>*</sup></label>
                                        <textarea
                                            rows={5}
                                            className={comment.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder="Enter your message here"
                                            name={comment.name}
                                            value={comment.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.toggleModal} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const st = this.state;
            const model = {
                leaveCode: st.leaveCode,
                status: st.status.value === 'true',
                comment: st.comment.value,
            };

            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;